<template>
    <div class="columns is-centered is-multiline has-text-centered">
        <div v-for="skill in skills" :key="skill.id" class="column is-3 skill">
            <p class="count">{{ skill.count }}</p>
            <p class="name">{{ skill.id }}</p>
        </div>
        <div v-if="skills.length === 0">No hay trámites que mostrar</div>
    </div>
</template>

<script>
export default {
    name: "skills",
    props: {
        skills: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style lang="scss" scoped>
.skill {
    border: 2px solid #275f92;
    margin: 1rem;
    padding: 0.1rem;
    border-radius: 0.5rem;

    display: flex;
    align-items: center;
    justify-content: center;

    &.is-danger {
        border: 2px solid red;
        background-color: lightcoral;
    }

    .name {
        font-weight: 500;
        padding: 1rem;
    }

    .count {
        font-size: 2rem;
        padding: 0.5rem;
        font-weight: bold;
    }
}
</style>